import { mediaUrl } from './mediaUrl';
import { resolveModelIconUrl } from './modelIconUrl';

/**
 * Image URL for assistant list/chat avatars: avatar first, then model icon, else undefined (use generic icon).
 */
export function assistantDisplayImageSrc(assistant) {
  if (!assistant) return undefined;
  if (assistant.avatar_url) {
    const u = mediaUrl(assistant.avatar_url);
    if (u) return u;
  }
  if (assistant.model_icon) {
    const u = resolveModelIconUrl(assistant.model_icon);
    if (u) return u;
  }
  return undefined;
}
